<template>
  <b-modal
    id="pagarDespesa"
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    size="xl"
    title="Pagar Despesa"
  >
    <b-card>
      <b-alert :variant="getErrors.color" v-if="getErrors.hasMessage" show>
        <div
          class="alert-body"
          v-for="(error, index) in getErrors.messageArray"
          :key="index"
        >
          {{ error[0] }}
        </div>

        <div class="alert-body">{{ getErrors.message }}</div>
      </b-alert>
      <validation-observer ref="despesaCadastroValidation">
        <b-row>
          <!--  DATA VENCIMENTO -->
          <b-col>
            <validation-provider
              #default="{ errors }"
              name="Data de Pagamento"
              rules="required"
            >
              <b-form-group label="Data de Pagamento" label-for="pagamento">
                <b-form-datepicker
                  id="pagamento"
                  v-model="data_pagamento"
                  :date-format-options="{
                    day: 'numeric',
                    month: 'numeric',
                    year: 'numeric',
                  }"
                  close-button
                  hide-header
                  label-close-button="Fechar"
                  label-reset-button="Apagar Data"
                  label-help=""
                  locale="pt-BR"
                  placeholder="Data"
                  reset-button
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>

          <!--  NOTA FISCAL / REFERÊNCIA -->
          <b-col>
            <b-form-group label="Nota Fiscal/Referência" label-for="referencia">
              <validation-provider name="Cód. Referência" rules="max:36">
                <b-form-input
                  id="referencia"
                  v-model="despesa.referencia"
                  disabled
                />
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <!-- DESCRIÇÃO -->
          <b-col>
            <validation-provider
              #default="{ errors }"
              name="Descrição"
              rules="required"
            >
              <b-form-group label="Descrição" label-for="descricao">
                <b-form-input
                  id="descricao"
                  v-model="despesa.descricao"
                  disabled
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>

          <b-col>
            <validation-provider
              #default="{ errors }"
              name="Forma de Pagamento"
              rules="required"
            >
              <b-form-group
                label="Forma de Pagamento"
                label-for="formaPagamento"
              >
                <b-form-select
                  v-model="despesa.forma_pagamento"
                  :options="formas"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <!-- VALOR -->
          <b-col>
            <validation-provider
              #default="{ errors }"
              name="Valor"
              rules="required|between:0,999999"
            >
              <b-form-group label="Valor" label-for="valor">
                <b-input-group prepend="R$">
                  <money
                    id="valor"
                    v-model="despesa.total_liquido"
                    @input="calculaTotal()"
                    v-bind="money"
                    class="form-control"
                  />
                </b-input-group>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>

          <!-- JUROS -->
          <b-col>
            <validation-provider
              #default="{ errors }"
              name="Juros"
              rules="required|between:0,999999"
            >
              <b-form-group label="Juros" label-for="juros">
                <b-input-group prepend="R$">
                  <money
                    id="juros"
                    v-model="juros"
                    v-bind="money"
                    class="form-control"
                    @input="calculaTotal()"
                  />
                </b-input-group>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <!-- TOTAL -->
          <b-col>
            <validation-provider
              #default="{ errors }"
              name="Valor"
              rules="required|between:0,999999"
            >
              <b-form-group label="Total" label-for="valor_parcela">
                <b-input-group prepend="R$">
                  <money
                    id="valor"
                    v-model="despesa.valor"
                    :value="despesa.valor"
                    v-bind="money"
                    class="form-control"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <validation-provider name="Observação" rules="max:100">
              <label for="textarea-default">Observação</label>
              <b-form-input id="textarea-default" v-model="observacao" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>

          <b-col>
            <validation-provider
              #default="{ errors }"
              name="Conta"
              rules="required"
            >
              <b-form-group label="Conta" label-for="conta">
                <v-select
                  style="background-color: white"
                  id="conta"
                  v-model="conta_id"
                  :reduce="(contas) => contas.id"
                  label="nome"
                  :options="contas"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
      <b-row class="mt-2">
        <b-col>
          <b-button
            :disabled="submit"
            block
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            @click="pagar"
            variant="success"
          >
            <template>
              <b-spinner v-if="spinner" small />
              <span v-if="spinner">Aguarde...</span>
              <span v-else>Pagar Despesa</span>
            </template>
          </b-button>
        </b-col>
        <b-col>
          <b-button
            block
            variant="outline-secondary"
            @click="$bvModal.hide('pagarDespesa')"
          >
            Fechar
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-modal>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BModal,
  BFormGroup,
  BFormDatepicker,
  BFormInput,
  BInputGroup,
  BFormSelect,
  BFormTextarea,
  BFormSpinbutton,
  BInputGroupPrepend,
  BSpinner,
  BAlert,
  VBToggle,
} from "bootstrap-vue";
import vSelect from "vue-select";
import money from "v-money";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { min, max, required } from "@validations";
import { mapState, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import formaPagamento from "../formaPagamento.js";
export default {
  directives: { "b-toggle": VBToggle },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BModal,
    BFormGroup,
    BInputGroupPrepend,
    BFormDatepicker,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BFormSpinbutton,
    BSpinner,
    vSelect,
    BFormSelect,
    ValidationObserver,
    ValidationProvider,
    BAlert,
    ToastificationContent,
    VBToggle,
  },

  props: ["despesa"],
  data() {
    return {
      errors: false,
      required,
      min,
      max,
      spinner: false,
      submit: false,
      data_pagamento: this.$getDate.hoje(),
      juros: "",
      observacao: "",
      conta_id: "",
      ...formaPagamento,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      getErrors: {
        hasMessage: false,
        color: "danger",
        message: "",
        messageArray: "",
      },
    };
  },

  mounted() {
    this.$store.dispatch("contas/listaContas");
  },

  computed: {
    ...mapState({
      contas: (state) => state.contas.contas,
    }),
  },

  methods: {
    calculaTotal() {
      this.despesa.valor = this.despesa.total_liquido + this.juros;
    },
    pagar() {
      this.$refs.despesaCadastroValidation.validate().then((success) => {
        if (success) {
          this.spinner = true;
          this.submit = true;
          this.errors = false;

          let payload = {
            ...this.despesa,
            data_pagamento: this.data_pagamento,
            juros: this.juros,
            observacao: this.observacao,
            conta_id: this.conta_id
          };
          this.$http
            .put(
              `adm/despesas/pagamentos/${this.despesa.pagamento_id}`,
              payload
            )
            .then((res) => {
              if (res.data) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Despesa Paga com Sucesso!",
                    icon: "InfoIcon",
                    variant: "success",
                  },
                });
              }
              this.getErrors = false;
              this.$refs.despesaCadastroValidation.reset();
              this.$store.dispatch("despesas/listaDespesas");
              this.$bvModal.hide('pagarDespesa')
            })
            .catch((error) => {
              let erro = this.$responseMessages.getMessage(error, null);
              this.getErrors = erro;
            })
            .finally(() => {
              this.spinner = false;
              this.submit = false;
            });
        }
      });
    },
  },
};
</script>

<style>
</style>